import { css } from 'styled-components';
import { rem } from 'polished';

const isFavoriteCueStyles = () => css`
    &:after {
        background-color: transparent;
        border-radius: 50%;
        box-shadow: none;
        content: '';
        height: ${rem(8)};
        position: absolute;
        right: ${rem(8)};
        top: ${rem(8)};
        transition: all 0.3s ease-in-out;
        width: ${rem(8)};
        z-index: 1;

        ${({ isFavorite }) =>
            isFavorite &&
            css`
                background-color: ${({ theme }) => theme.site.library.isFavorite.backgroundColor};
                box-shadow: ${({ theme }) => theme.base.boxShadow.elevationSmall};
            `}
    }
`;

export default isFavoriteCueStyles;
